import React, {useState, useEffect} from "react";
import dotenv from "dotenv";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import App from "./containers/common/App";
import AssistantApp from "./containers/assistantApp/AssistantApp";
import ErrorHandler from "./containers/common/ErrorHandler";
import "./app.less";
import {URL_ASSISTANT} from "./models/url";

dotenv.config();

const shouldRenderAssistantApp = () => {
    const path = window.location.pathname;

    return path === URL_ASSISTANT || path.startsWith(`${URL_ASSISTANT}/`);
};

const AppRoot: React.FC = () => {
    const [isAssistantApp, setIsAssistantApp] = useState(shouldRenderAssistantApp());

    useEffect(() => {
        const handleLocationChange = () => {
            setIsAssistantApp(shouldRenderAssistantApp());
        };

        window.addEventListener("popstate", handleLocationChange);

        // Intercept pushState/replaceState for programmatic navigation
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;

        window.history.pushState = function (data, unused, url) {
            originalPushState.call(window.history, data, unused, url);
            handleLocationChange();
        };

        window.history.replaceState = function (data, unused, url) {
            originalReplaceState.call(window.history, data, unused, url);
            handleLocationChange();
        };

        return () => {
            window.removeEventListener("popstate", handleLocationChange);
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, []);

    return (
        <DndProvider backend={HTML5Backend}>
            <ErrorHandler>
                {isAssistantApp ? <AssistantApp /> : <App />}
            </ErrorHandler>
        </DndProvider>
    );
};

const app = <AppRoot />;
export default app;
